import { useContext } from 'react';
import { BILoggerContext } from './BILoggerContext';
export var useBi = function () {
    return useContext(BILoggerContext);
};
export var useOwnerBi = function () {
    return useContext(BILoggerContext);
};
export var useVisitorBi = function () {
    return useContext(BILoggerContext);
};
//# sourceMappingURL=useBi.js.map